import { render, staticRenderFns } from "./uploadImgTable.vue?vue&type=template&id=364500c6&scoped=true"
import script from "./uploadImgTable.vue?vue&type=script&lang=js"
export * from "./uploadImgTable.vue?vue&type=script&lang=js"
import style0 from "./uploadImgTable.vue?vue&type=style&index=0&id=364500c6&prod&lang=scss&scoped=true"
import style1 from "./uploadImgTable.vue?vue&type=style&index=1&id=364500c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364500c6",
  null
  
)

export default component.exports